/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // カート追加ボタンのクリックを監視する関数
  function handleAddToCart(e) {
    const button = e.currentTarget;
    const form = button.closest('form[action="/cart/add"]');

    if (!form) return;

    // Broadcastテーマの既存の処理を止める
    e.stopImmediatePropagation();
    e.preventDefault();

    const formData = new FormData(form);

    // ボタンをローディング状態にする（任意）
    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
    })
    .then(response => response.json())
    .then(data => {
      // エラーがある場合はリロードしない
      if (data.status) {
        console.error('Cart Error:', data.description);
        button.classList.remove('is-loading'); // ローディング解除
        return;
      }
      // カート追加が成功したらページをリロード
      window.location.reload();
    })
    .catch((error) => {
      console.error('Fetch Error:', error);
      button.classList.remove('is-loading'); // ローディング解除
      form.submit(); // 失敗した場合は通常の送信を試みる
    });
  }

  // ページの読み込み完了後に関数をセットアップ
  document.addEventListener('DOMContentLoaded', function() {
    // セレクターをより具体的にする
    const addToCartButtons = document.querySelectorAll('form[action="/cart/add"] [type="submit"], form[action="/cart/add"] button[name="add"]');
    
    addToCartButtons.forEach(button => {
      button.addEventListener('click', handleAddToCart);
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();